module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/print-585ea199562c95d359f44deed790a874.svg";